const LAUNCH_URL_KEY = 'native.oauthLaunchUrlHandled';

/** Отметка живёт в sessionStorage: переживает перезагрузку страницы, но не новый запуск. */
export const wasLaunchUrlHandled = (url: string) => {
  try {
    return globalThis.sessionStorage?.getItem(LAUNCH_URL_KEY) === url;
  } catch {
    return false;
  }
};

export const markLaunchUrlHandled = (url: string) => {
  try {
    globalThis.sessionStorage?.setItem(LAUNCH_URL_KEY, url);
  } catch {
    // Хранилище запрещено – ссылка сработает, повтор на F5 останется прежним.
  }
};
